import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import { withRouter, useHistory } from 'react-router-dom';
import classnames from 'classnames';

import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { compareEmails, createdUpdatedInfo, formatDatetime, formatEmail, getDate, getGuid, getTsDate, notify } from '../../../utils';
import useTypedForm, { OmitProps } from '../../../components/custom/hookForm/useTypedForm';
import { ChangeEvent, ChoiceEmployee, IBlobFile, IFile, IUser, SupportTicket, TicketCommunication } from '../../../globals/interfaces';
import _ from 'lodash';
import { useAppContext } from '../../../context';
import { useRecoilState, useRecoilValue } from 'recoil';
import { selectedTicketIdState, supportRequestModalState, supportTicketsState } from './atoms';
import moment from 'moment';
import { FormInputProps } from '../../../components/custom/hookForm/FormInput';
import { FormGroup } from 'reactstrap';
import apiClient from '../../../apiClient';
import Attachments from './Attachments';
import { Input } from 'reactstrap';
import { Button } from 'reactstrap';
import Comment from './Comment';
import CloseRequestModal from './CloseRequestModal';
import useSupportTickets from './useSupportTickets';
import AssignUserModal from './AssignUserModal';
import UpdateModalBody from './UpdateModalBody';
import CreateModalBody from './CreateModalBody';
import { getUnreadMessagesCount } from '.';
import { screenShotState } from '../../../globals/atoms';
import { createSchema, updateSchema } from './yupSchema';
import { yupResolver } from '@hookform/resolvers/yup';

export type CreateUpdateTicketWithParam = (fields?: Partial<SupportTicket>, keepOpen?: boolean) => (e?: React.BaseSyntheticEvent<object, any, any>) => Promise<void>;
export type SupportRequestFormInputProps = React.FC<Omit<FormInputProps<SupportTicket>, OmitProps>>;

interface Props {

}

export default function SupportRequestModal({

}: Props) {

    const { user } = useAppContext();
    const history = useHistory();
    const [modal, setModal] = useRecoilState(supportRequestModalState);
    const {
        supportTickets,
        setSupportTickets,
        updateData
    } = useSupportTickets(undefined);
    const selectedTicketId = useRecoilValue(selectedTicketIdState);
    const ticket = (supportTickets || []).find(ticket => ticket.id === selectedTicketId);
    const update = Boolean(ticket);
    const [attachments, setAttachments] = useState<Array<IBlobFile>>([]);
    const [userDetails, setUserDetails] = useState<ChoiceEmployee>();
    const [closeModal, setCloseModal] = useState(false);
    const [assignModal, setAssignModal] = useState(false);
    const screenshot = useRecoilValue(screenShotState);

    const {
        formState: {
            isValid,
            errors
        },
        setValue,
        handleSubmit,
        reset,
        trigger,
        watch,
        FormInput
    } = useTypedForm<SupportTicket>({
        resolver: yupResolver(update ? updateSchema :  createSchema)
    });

    const type = watch('type');

    useEffect(() => {
        const now = getTsDate();
        if (ticket) {
            const copy = _.cloneDeep(ticket);
            copy.modifiedAt = now;
            copy.modifiedBy = user.s_email;
            reset(copy);
        } else {
            reset({
                guid: getGuid(),
                unit: user.s_unit,
                createdBy: user.s_email,
                modifiedBy: user.s_email,
                createdAt: now,
                modifiedAt: now,
                status: 'OPEN',
                type: 'EOS',
                title: `${history.location.pathname}`,
                attachments: []
            });
        }
        trigger();

        const readCommunication = async () => {
            if (!ticket || compareEmails(ticket.createdBy, user.s_email)) return;
            alert('work 1');
            const count = getUnreadMessagesCount(ticket, user);
            if (count) {
                try {
                    alert('work 2');
                    await apiClient.put(`/support-ticket/communication`, {
                        id: ticket.id,
                        now: getTsDate()
                    });
                    const copy = _.cloneDeep(supportTickets);
                    const updateIndex = copy.findIndex(item => item.id === selectedTicketId);
                    const { ticketCommunication } = copy[updateIndex];
                    for (const item of ticketCommunication) {
                        item.viewStatus.viewed = true;
                    }
                    updateData(copy);
                    alert('done');
                } catch (err) {
                    alert(err);
                }
            }
        }
        readCommunication();
    }, [ticket, user, history, modal]);

    useEffect(() => {
        if (ticket) {
            const getAttachments = async () => {
                try {
                    const res = await apiClient.get(`/support-ticket/attachments?guid=${ticket.guid}&createdBy=${ticket.createdBy}`);
                    const { files, userData } = res.data;
                    setAttachments(files);
                    setUserDetails(userData);
                } catch (err) {
                    alert(err);
                }
            }
            getAttachments();
        } else {
            setAttachments([]);
        }
    }, [ticket]);

    const closingNotes = watch('closingNotes');
    const resolved = watch('resolved');

    const addAttachments = (files: Array<IFile>) => {
        setValue('attachments', files);
    }

    const createUpdateTicket = async (data: SupportTicket, keepOpen?: boolean) => {
        try {
            const method = ticket ? 'put' : 'post';
            if (method === 'post') {
                if (!data.attachments) {
                    data.attachments = [];
                }
                data.attachments.push(screenshot);
            }
            const res = await apiClient[method](`/support-ticket`, data);
            const copy = _.cloneDeep(supportTickets);
            if (ticket) {
                const updateIndex = copy.findIndex(item => item.id === ticket.id);
                if (data.status === 'CLOSED') {
                    copy.splice(updateIndex, 1);
                } else {
                    copy[updateIndex] = data;
                }
            } else {
                copy.push(res.data);
            }
            updateData(copy);
            setAssignModal(false);
            if (!keepOpen) {
                setModal(false);
                setCloseModal(false);
            }
            notify(`Ticket ${ticket ? 'Updated' : 'Created'}`);
        } catch (err) {
            alert(err);
        }
    }

    const createUpdateTicketWithParam = (fields?: Partial<SupportTicket>, keepOpen?: boolean) => {
        return handleSubmit((data) => {
            // Combine form data with additional fields if necessary
            const combinedData = { ...data };
            if (fields) {
                for (const key in fields) {
                    combinedData[key] = fields[key];
                }
            }
            return createUpdateTicket(combinedData, keepOpen);
        });
    };

    const sendMessage = async (message: string) => {
        if (!ticket || !selectedTicketId) return;
        try {
            const res = await apiClient.post(`/support-ticket/communication`, {
                ticketId: ticket.id,
                message,
                createdBy: user.s_email,
                createdAt: getTsDate(),
                userId: ticket.createdBy
            });

            const copy = _.cloneDeep(supportTickets);
            const updateIndex = copy.findIndex(item => item.id === selectedTicketId);
            copy[updateIndex].ticketCommunication.push(res.data);
            updateData(copy);

            // setSupportTickets(prev => {
            //     const copy = _.cloneDeep(prev);
            //     const updateIndex = copy.findIndex(item => item.id === selectedTicketId);
            //     copy[updateIndex].ticketCommunication.push(res.data);
            //     return copy;
            // });
        } catch (err) {
            alert(err);
        }
    }

    const setOwnership = (value: string | null) => {
        setValue('assignedTo', value);
    }

    const setResolved = (value: boolean) => {
        setValue('resolved', value);
    }

    const toggle = () => setModal(!modal);

    return (
        <CustomModal isOpen={modal} toggle={toggle} update={update}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <FlexContainer>
                        <BackButton onClick={toggle} />
                        <h4 className={'pl-2'}>Support Request</h4>
                    </FlexContainer>
                    <RenderTakeOwnership
                        user={user}
                        ticket={ticket}
                        setAssignModal={setAssignModal}
                    />
                </HeaderContainer>
            </ModalHeader>
            <CustomModalBody>
                {
                    update ? (
                        <UpdateModalBody 
                            ticket={ticket}
                            attachments={attachments}
                            setAttachments={setAttachments}
                            addAttachments={addAttachments}
                            sendMessage={sendMessage}
                            user={user}
                            userDetails={userDetails}
                        />
                    ) : (
                        <CreateModalBody 
                            FormInput={FormInput}
                            addAttachments={addAttachments}
                            setValue={setValue}
                            type={type}
                        />
                    )
                }
            </CustomModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    {
                        ticket && (
                            <div>
                                <Label>
                                    {createdUpdatedInfo(ticket, true)}
                                </Label>
                            </div>
                        )
                    }
                    <FooterButtonsContainer update={Boolean(ticket)}>
                        <RenderCloseRequest
                            user={user}
                            ticket={ticket}
                            setCloseModal={setCloseModal}
                        />
                        <ActionIcon
                            type={'save'}
                            onClick={createUpdateTicketWithParam()}
                            disabled={!isValid}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
            <CloseRequestModal
                modal={closeModal}
                setModal={setCloseModal}
                closingNotes={closingNotes}
                resolved={resolved}
                setResolved={setResolved}
                createUpdateTicketWithParam={createUpdateTicketWithParam}
                FormInput={FormInput}
            />
            <AssignUserModal 
                modal={assignModal}
                setModal={setAssignModal}
                ticket={ticket}
                setOwnership={setOwnership}
                createUpdateTicketWithParam={createUpdateTicketWithParam}
            />
        </CustomModal>
    );
}

const RenderUpdateFields = ({
    ticket,
    user,
    addComment,
    FormInput
}: {
    ticket: SupportTicket;
    user: IUser;
    addComment: (message: string) => Promise<void>;
    FormInput: React.FC<Omit<FormInputProps<SupportTicket>, OmitProps>>;
}) => {

    const [message, setMessage] = useState('');

    const handleAddComment = async () => {
        await addComment(message);
        setMessage('');
    }

    if (!ticket) return null;

    return (
        <div>
            <Label>Messages:</Label>
            <TicketCommunicationContainer>
                {
                    _.get(ticket, 'ticketCommunication', []).map((item: TicketCommunication) => (
                        <div
                            className={classnames(
                                'message',
                                item.createdBy === user.s_email ? 'user' : 'other-user'
                            )}
                        >
                            <Comment item={item} isUser={item.createdBy === user.s_email} />
                        </div>
                    ))
                }
            </TicketCommunicationContainer>
            <FlexContainer>
                <Input
                    type={'textarea'}
                    value={message}
                    onChange={(e: ChangeEvent) => setMessage(e.target.value)}
                    className={'normal-text'}
                />
                <SendMessageIcon
                    className={'fa-solid fa-paper-plane-top ml-2'}
                    onClick={handleAddComment}
                />
            </FlexContainer>
        </div>
    );
}

const RenderTakeOwnership = ({
    ticket,
    user,
    setAssignModal
}: {
    ticket: SupportTicket | undefined;
    user: IUser;
    setAssignModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const {isDev} = user;

    if (!ticket) {
        return null;
    }

    const text = ticket.assignedTo ? 
        formatEmail(ticket.assignedTo) :
        `Assign Ticket`;

    const handleClick = () => {
        if (isDev || !ticket.assignedTo) {
            setAssignModal(true);
        }
    }

    // ownership taken by someone else
    return (
        <Button onClick={handleClick}>{text}</Button>
    );
}

const CloseRequest = ({
    setCloseModal
}: {
    setCloseModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    return (
        <Button onClick={() => setCloseModal(true)}>
            Close Request
            <CheckIcon className={'fa-solid fa-check'} />
        </Button>
    );
}

const RenderCloseRequest = ({
    user,
    ticket,
    setCloseModal
}: {
    user: IUser;
    ticket: SupportTicket | undefined;
    setCloseModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {

    if (!ticket) return <div></div>;

    if (user.s_email === ticket.createdBy || user.s_email === ticket.assignedTo) {
        return (
            <CloseRequest setCloseModal={setCloseModal} />
        );
    }

    return <div></div>;
}

const CustomModal = styled(Modal)<{ update: boolean }>`
    width: 100%;
    max-width: ${p => p.update ? '95%' : '700px'};
`;

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const CustomModalBody = styled(ModalBody)`

`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
    gap: 25px;
`;

const TicketCommunicationContainer = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 300px;
    border: 1px solid #ccc;
    padding: 10px;
    overflow-y: auto;

    .message {
        display: flex;
        margin: 5px 0;
        padding: 10px;
        border-radius: 10px;
        max-width: 80%;
    }
    .message.other-user {
        justify-content: flex-start;
        background-color: #e1ffc7;
    }
    .message.user {
        justify-content: flex-end;
        background-color: #cce5ff;
        align-self: flex-end;
    }
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 2px;
    margin-bottom: 10px;
`;

const SendMessageIcon = styled.i`
    font-size: 24px;
    color: #5da81c;
`;

const CheckIcon = styled.i`
    font-size: 14px;
    margin-left: 2px;
`;